import { showJudgeControls } from "./judgeControls";

/**
 * Update the judge-action controls and the role selector for a position.
 * Judge-control visibility is delegated to showJudgeControls so a server
 * override (e.g. CM status) keeps them visible regardless of position.
 */
export function updateActionCommands(side: string) {
  showJudgeControls(side === "jud");

  // Update role selector
  for (
    let i = 0,
      role_select = <HTMLSelectElement>document.getElementById("role_select");
    i < role_select.options.length;
    i++
  ) {
    if (side === role_select.options[i].value) {
      role_select.options.selectedIndex = i;
      return;
    }
  }
}
window.updateActionCommands = updateActionCommands;
